import i18n from '@/i18n'

export const voicebotSortOptions = [
    {
        label: `${i18n.t('extensions.sort.userName.asc')} - ${i18n.t('sorting.asc')}`,
        value: 'VoicebotName-asc',
        prop: 'VoicebotName',
        order: 'asc'
    },
    {
        label: `${i18n.t('extensions.sort.userName.desc')} - ${i18n.t('sorting.desc')}`,
        value: 'VoicebotName-desc',
        prop: 'VoicebotName',
        order: 'desc'
    },
    {
        label: `${i18n.t('extensions.sort.callDuration.asc')} - ${i18n.t('sorting.asc')}`,
        value: 'callDuration-asc',
        prop: 'callDuration',
        order: 'asc'
    },
    {
        label: `${i18n.t('extensions.sort.callDuration.desc')} - ${i18n.t('sorting.desc')}`,
        value: 'callDuration-desc',
        prop: 'callDuration',
        order: 'desc'
    },
]
